import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useContextStore } from "./useContextStore";
import { MeAPI } from "../utils/generated/api-user";

export const useAuthStore = defineStore("auth", () => {
  const me = ref(null);
  const contextStore = useContextStore();

  const charity = computed(() => me.value?.charity);

  async function authenticate(payload = {}) {
    const currentPath = payload.currentPath;
    const isSuperadminRoute = currentPath?.path?.startsWith("/superadmin");
    const billingId = isSuperadminRoute ? undefined : currentPath?.params?.charityId;
    const committeeCode = currentPath?.params?.committeeCode;

    try {
      const result = billingId ? await MeAPI.getMeWithBillingId(billingId, committeeCode) : await MeAPI.getMe();

      if (!result) {
        me.value = null;
        return null;
      }

      me.value = {
        id: result.id,
        login: result.login,
        userName: result.userName,
        userRoles: result.userRoles,
        charityBillingId: result.charityBillingId,
        charity:
          billingId && result.charityId ?
            {
              billingId: result.charityBillingId,
              id: result.charityId,
              restricted: result.charityRestricted,
              plan: result.charityPlan,
              logoUrl: result.charityLogoUrl,
              name: result.charityName,
              creationDate: result.charityCreationDate,
              portalUrl: result.charityPortalUrl,
            }
          : null,
      };

      contextStore.setCharity(me.value.charity);

      return me.value;
    } catch (error) {
      if (error?.name === "ForbiddenError" || error?.name === "NotFoundError") {
        throw error;
      }
      console.error("Failed to load user data:", error);
      me.value = null;
      return null;
    }
  }

  function logout() {
    me.value = null;
  }

  return {
    me,
    charity,
    authenticate,
    logout,
  };
});
